import type {Grouping} from '@/global/types';

export function getBranchById(items: Grouping[], id: Grouping['id']): null | Grouping {

    let child: null | Grouping;

    for (let i = 0; i < items.length; i++) {

        if (items[i].id === id) {

            return items[i];
        }

        if (items[i].children) {

            child = getBranchById(items[i].children as Grouping[], id);

            if (child) {

                return child;
            }
        }
    }

    return null;
}

export function extendTreeWithParentId(items: Grouping[], parentId: null | number = null): Grouping[] {

    for (let i: number = 0; i < items.length; i++) {

        items[i].parent_id = parentId;

        if (items[i].children) {

            items[i].children = extendTreeWithParentId(items[i].children as Grouping[], items[i].id);
        }
    }

    return items;
}

export function getParentsChain(items: Grouping[], item: Grouping): Grouping[] {

    // Make sure every grouping has parent
    items = extendTreeWithParentId(items);

    let chain: Grouping[] = [];
    let parent: null | Grouping = item.parent_id ? getBranchById(items, item.parent_id) : null;

    while (parent) {

        chain.unshift(parent);

        parent = parent.parent_id ? getBranchById(items, parent.parent_id) : null;
    }

    return chain;
}